import { Link } from 'react-router-dom';
import { hotVideos } from '@/mocks/videos';

export default function HeroSection() {
  const featured = hotVideos[0];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        {featured && (
          <img
            src={featured.thumbnail}
            alt=""
            className="w-full h-full object-cover object-top"
          />
        )}
        {/* Overlay Gradients */}
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/40"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/60 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="max-w-lg">
            {/* Badge */}
            <div className="flex items-center gap-2 mb-4">
              <span className="px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-bold whitespace-nowrap">
                今日推荐
              </span>
              <span className="px-3 py-1 rounded-full bg-background-300/80 text-foreground-600 text-xs whitespace-nowrap">
                {featured?.category === 'dianshiju' ? '电视剧' :
                 featured?.category === 'dianying' ? '电影' :
                 featured?.category === 'zongyi' ? '综艺' :
                 featured?.category === 'dongman' ? '动漫' :
                 featured?.category === 'jilupian' ? '纪录片' :
                 featured?.category === 'shaoer' ? '少儿' :
                 featured?.category === 'duanju' ? '短剧' : '体育'}
              </span>
              {featured && (
                <span className="flex items-center gap-1 text-foreground-500 text-xs">
                  <i className="ri-star-fill text-primary-500 text-xs"></i>
                  {featured.rating}
                </span>
              )}
            </div>

            {/* Title */}
            <h1 className="text-3xl md:text-5xl font-bold text-foreground-950 mb-3 leading-tight">
              {featured?.title || '蓝莓视频'}
            </h1>

            {/* Description */}
            <p className="text-sm md:text-base text-foreground-500 mb-6 leading-relaxed line-clamp-2">
              {featured?.description}
            </p>

            {/* Meta */}
            {featured && (
              <div className="flex items-center gap-4 mb-6 text-sm text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {featured.views}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {featured.duration}
                </span>
                <span>{featured.releaseDate}</span>
              </div>
            )}

            {/* CTA Buttons */}
            <div className="flex items-center gap-3 flex-wrap">
              <Link
                to={featured ? `/video/${featured.id}` : '/'}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-foreground-950 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-fill text-lg"></i>
                立即观看
              </Link>
              <Link
                to={featured ? `/category/${featured.category}` : '/'}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-200/80 text-foreground-700 font-medium text-sm hover:bg-background-300 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-list-check"></i>
                更多推荐
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}